import { render } from "./SportFeaturePlaceholder.vue?vue&type=template&id=57b3c8ae&scoped=true"
import script from "./SportFeaturePlaceholder.vue?vue&type=script&lang=js"
export * from "./SportFeaturePlaceholder.vue?vue&type=script&lang=js"

import "./SportFeaturePlaceholder.vue?vue&type=style&index=0&id=57b3c8ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57b3c8ae"]])

export default __exports__